import {
    Box,
    Button,
    CircularProgress,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchClusterData } from 'store';
import { setImportFileName } from 'store/slices/segmenterSlice';
import { resetChatHistories } from 'store/slices/segmenterChatSlice';

import classes from "./ImportFile.module.scss";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const ImportFileBox = React.memo(({ onCancel }) => {

    const { inputFileList, inputDataFileName, inputFileMapping, loadingImportFiles } = useSelector(
        (state) => state.segmenter
    );
    const dispatch = useDispatch();
    const [selectedImportFile, setSelectedImportFile] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);


    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbarOpen(false);
    };

    const handleSubmision = () => {
        dispatch(setImportFileName(selectedImportFile));
        dispatch(fetchClusterData()).then(() => {
            dispatch(resetChatHistories());
        });
        setSnackbarOpen(true);
    };

    useEffect(() => {
        if (inputFileList.length > 0) {
            setSelectedImportFile(inputDataFileName ?? inputFileList[0]);
        }
    }, [inputFileList, inputDataFileName]);

    return (

        <Box className={classes.body}>
            <section className={classes.section}>
                <section className={classes.header}>
                    <Typography className={classes.title}>Import Data</Typography>
                    <Typography className={classes.label}>Select a file below to begin importing data</Typography>
                </section>
                <section className={classes.formSection}>
                    <FormControl component="fieldset" className={classes.formControlSection}>
                        {loadingImportFiles ? (
                            <div className={classes.importLoader}>
                                <CircularProgress size="20px" />
                            </div>
                        ) : (
                            <RadioGroup
                                value={selectedImportFile}
                                onChange={(e) => {
                                    const inputFile = e.target.value;
                                    setSelectedImportFile(inputFile);
                                }}
                            >
                                {Object.entries(inputFileMapping).map(([inputFile, outputFile]) => (
                                    <FormControlLabel
                                        key={inputFile}
                                        value={inputFile}
                                        control={<Radio />}
                                        label={outputFile}
                                    />
                                ))}
                            </RadioGroup>
                        )}
                    </FormControl>
                </section>
            </section>
            <section className={classes.footer}>
                <Button onClick={onCancel} variant="outlined" className={classes.boxButton}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmision}
                    disabled={inputFileList.length === 0 || loadingImportFiles}
                    variant="contained"
                    className={classes.boxButton}
                >
                    Import
                </Button>
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <MuiAlert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                        File Successfully Uploaded
                    </MuiAlert>
                </Snackbar>
            </section>
        </Box>
    );
});

export default ImportFileBox;
